import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccomplishmentsComponent } from 'src/app/view/accomplishments/accomplishments.component';
import { CoComponent } from 'src/app/view/accomplishments/co/co.component';
import { CulturalComponent } from 'src/app/view/accomplishments/cultural/cultural.component';
import { GamesComponent } from 'src/app/view/accomplishments/games/games.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    AccomplishmentsComponent,
    CoComponent,
    GamesComponent,
    CulturalComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:AccomplishmentsComponent,children:[
        {path:'co',component:CoComponent},
        {path:'games',component:GamesComponent},
        {path:'cultural',component:CulturalComponent}
      ]}
    ])
  ],
  exports:[
    RouterModule
  ]
})
export class AccomplishmentModule { }
